import { Component, OnInit, Input } from '@angular/core';

import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UiFactory } from '../../core/ui/ui-factory';
import { ListSelectModel, LIST_SELECT_DEFAULTS } from './list-select-model';
import { BehaviorService } from '../../core/behavior/behavior.service';
import { ValidationService } from '../../core/validation/validation.service';

@Component({
  selector: 'pg-list-select-factory, grit-list-select-factory',
  templateUrl: './pg-list-select-factory.component.html',
  styleUrls: ['./pg-list-select-factory.component.scss'],
})
export class PgListSelectFactoryComponent extends UiFactory {
  @Input()
  model: any;

  get listSelectModel(): ListSelectModel {
    return this.model;
  }

  @Input()
  parentFormGroup: FormGroup;

  constructor(
    public behaviorService: BehaviorService,
    public _validationService: ValidationService
  ) {
    super(behaviorService);
  }

  ngOnInit() {
    super.ngOnInit();
    this._setModelDefaults();
    if (!this.parentFormGroup) {
      throw new Error(
        'parentFormGroup is a required for the list-select-factory to function'
      );
    } else if (!this.listSelectModel.formControlName) {
      throw new Error(
        'formControlName must be given a value for the list-select-factory to function'
      );
    } else if (
      this.listSelectModel.currentlyActiveOption >
      this.listSelectModel.options.length - 1
    ) {
      throw new Error(
        'currentlyActiveOption is not valid. must be equal to the options index in the array you would like to select.'
      );
    }
    if (this.listSelectModel.formControlName) {
      let control = this.parentFormGroup.get(
        this.listSelectModel.formControlName
      );
      if (!control) {
        if (this.listSelectModel.required) {
          this.parentFormGroup.addControl(
            this.listSelectModel.formControlName,
            new FormControl('', [Validators.required])
          );
        } else {
          this.parentFormGroup.addControl(
            this.listSelectModel.formControlName,
            new FormControl('', [])
          );
        }
      }
    }
    this._setCurrentlyActive();
  }

  private _setCurrentlyActive() {
    if (
      this.listSelectModel.currentlyActiveOption ||
      this.listSelectModel.currentlyActiveOption === 0
    ) {
      this.parentFormGroup
        .get(this.listSelectModel.formControlName)
        .setValue(
          this.listSelectModel.options[
            this.listSelectModel.currentlyActiveOption
          ].value
        );
    } else {
      return;
    }
  }

  private _setModelDefaults() {
    this.model = { ...LIST_SELECT_DEFAULTS, ...this.model };
  }
}
